import { useTranslation } from 'react-i18next';
import { BackInStockSubscriptionsGridView } from '~/components/catalog/back-in-stock-subscriptions';
import { PageContainer } from '~/components/page-container';
import { useHasAccess } from '~/lib/auth/use-has-access';

export function BackInStockSubscriptions() {
	const { t } = useTranslation();
	// The menu only hides the entry; BackInStockSubscriptions/GetAll requires the Catalog role, so gate a direct URL too
	const canView = useHasAccess()('Catalog');
	return (
		<PageContainer>
			{canView ? (
				<BackInStockSubscriptionsGridView />
			) : (
				<div className="rounded-lg border border-border bg-surface p-8 text-center text-sm text-foreground-muted">
					{t('catalog.backInStock.noAccess')}
				</div>
			)}
		</PageContainer>
	);
}
